import React from 'react'

import { useRouterScrollToTop } from '@domain-group/react-hooks'

import useAgencies from '@hooks/useAgencies'
import useBrands from '@hooks/useBrands'
import useIntercom from '@hooks/useIntercom'

interface ClientProps {
  children: React.ReactNode,
}

const Client = (props: ClientProps) => {
  const { children } = props

  useIntercom({ hideWidget: false })

  // Scroll Page to top when route changes
  useRouterScrollToTop()

  useAgencies({
    performHttpRequests: true,
    requestOptions: {
      include_agency_agency_providers: true,
      include_agency_attachments: true,
      include_agency_current_user_permissions: true,
      include_agency_deadline_group_deadline_group: true,
      include_agency_deadline_groups: true,
      include_agency_paid_plan_flag: true,
      include_agency_payment_method_payment_method: true,
      include_agency_payment_methods: true,
      include_attachment_file: true,
      include_brand_image_settings: true,
      include_brand_watermark_attachment: true,
    },
  })

  useBrands({ performHttpRequests: true })

  return children
}

export default Client
